import '../SideMenu.scss';

import { CountryFlag } from 'utilities/CountryFlag';
import MenuItem from 'components/MenuItem/MenuItem';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useStores } from 'index';

export const LanguageSubmenu = observer(() => {
  const ls = useStores().languagesStore;
  const ts = useStores().translationsStore;

  useEffect(() => {
    ls.loadLanguages();
  }, [ls]);

  return (
    <div className='submenu-container'>
      <div className='submenu-menu'>
        {ls.languageInfo.map((language) => {
          return (
            <MenuItem
              key={language.countryCode}
              label={language.displayName}
              onClick={() => ts.setLanguage(language.countryCode)}
              isActive={ls.userLanguage === language.countryCode}
              icon={<CountryFlag countryCode={language.countryCode} />}
              isSubmenu
            />
          );
        })}
      </div>
    </div>
  );
});

export default LanguageSubmenu;
